<template>
  <div class="combo-container">
    <!-- 数据表格 -->
    <template>
      <el-table :data="tableData" v-loading="loading" class="combo-table">
        <el-table-column prop="type" label="套餐类型"></el-table-column>
        <el-table-column prop="buyCount" label="购买张数"></el-table-column>
        <el-table-column prop="consumeCount" label="消费张数"></el-table-column>
        <el-table-column prop="remainCount" label="剩余张数"></el-table-column>
        <el-table-column prop="overCount" label="过期张数"></el-table-column>
      </el-table>

      <!-- 上方表格的分页器 -->
      <!--    <div class="pagination-container">
        <el-pagination
          @current-change="handleComboCurrentChange"
          :current-page="comboPageInfo.currentPage"
          :page-size="comboPageInfo.pageSize"
          :total="comboPageInfo.total"
          layout="prev, pager, next, jumper"
          background
        >
        </el-pagination>
      </div> -->
    </template>

    <!-- 空状态展示 -->
    <!-- <div class="empty-state">
            <p class="empty-text">暂无可用套餐</p>
            <el-button class="purchase-btn" @click="goToPurchase">购买套餐</el-button>
        </div> -->

    <template>
      <p class="title">交易明细</p>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="消费明细" name="shopping">
          <!-- 原有的shopping区域包裹在第一个tab下 -->
          <div class="search-bar">
            <el-form
              :inline="true"
              :model="queryParams"
              class="demo-form-inline"
            >
              <el-form-item label="交易时间">
                <el-date-picker
                  v-model="queryParams.dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <!-- 其他搜索条件保持不变 -->
              <!-- <el-form-item label="套餐订单号">
              <el-input
                v-model="queryParams.code"
                placeholder="请输入"
                clearable
                style="width: 200px"
              >
              </el-input>
            </el-form-item> -->
              <!-- <el-form-item label="套餐类型">
              <el-select v-model="queryParams.type" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="线上授权" value="线上授权"></el-option>
                <el-option label="标准授权" value="标准授权"></el-option>
                <el-option label="扩展授权" value="扩展授权"></el-option>
                <el-option label="商品授权" value="商品授权"></el-option>
              </el-select>
            </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button @click="resetQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table v-loading="loading1" :data="recordList" style="width: 100%">
            <el-table-column prop="createBy" label="时间" width="180">
              <template slot-scope="scope">
                {{ scope.row.createTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="code" label="订单号" width="180">
              <template slot-scope="scope">
                {{ scope.row.code || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="handType" label="操作类型">
              <template slot-scope="scope">
                <span v-if="scope.row.handType === 0">购买商品</span>
                <span v-else-if="scope.row.handType === 1">购买套餐</span>
                <span v-else-if="scope.row.handType === 2">退款</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="套餐类型">
              <template slot-scope="scope">
                {{ scope.row.type || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="handResult" label="本次操作">
              <template slot-scope="scope">
                {{ scope.row.handResult || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="remain" label="剩余张数">
              <template slot-scope="scope">
                {{ scope.row.remainCount || "0" }}张
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="操作员"></el-table-column>
          </el-table>

          <!-- 替换分页组件 -->
          <div class="pagination-container">
            <cus-pagination
              :total="total"
              :current-page.sync="currentPage"
              :page-size.sync="pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></cus-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="购买记录" name="recharge">
          <!-- 查询表单 -->
          <el-form :model="queryForm" class="search-form">
            <div class="form-row">
              <!-- 修改套餐类型为下拉选择 -->
              <el-form-item label="套餐类型">
                <el-select
                  v-model="queryForm.type"
                  placeholder="请选择套餐类型"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="线上授权" value="线上授权"></el-option>
                  <el-option label="标准授权" value="标准授权"></el-option>
                  <el-option label="扩展授权" value="扩展授权"></el-option>
                  <el-option label="商品授权" value="商品授权"></el-option>
                </el-select>
              </el-form-item>
              <!-- 订单编号输入 -->
              <!-- <el-form-item label="订单编号">
            <el-input
              v-model="queryForm.code"
              placeholder="请输入订单编号"
            ></el-input>
          </el-form-item> -->
              <!-- 下单时间范围选择 -->
              <el-form-item label="下单时间">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="queryForm.orderTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="form-row">
              <!-- 支付方式选择 -->
              <el-form-item label="支付方式" class="left-item">
                <el-select v-model="queryForm.payMode" placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="微信" :value="0"></el-option>
                  <el-option label="支付宝" :value="1"></el-option>
                  <el-option label="线下" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <!-- 搜索按钮 -->
              <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="onReset">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
          <!-- 交易明细表格 -->
          <el-table
            :data="transactionData"
            v-loading="loading2"
            class="transaction-table"
            row-key="id"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            :default-expand-all="true"
          >
            <el-table-column
              prop="code"
              label="套餐订单号"
              fixed="left"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="type"
              label="套餐类型"
              width="120"
            ></el-table-column>
            <el-table-column prop="count" label="购买数量总量" width="120">
              <template slot-scope="scope"> {{ scope.row.count }}张 </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.price"> ￥{{ scope.row.price }} </span>
              </template>
            </el-table-column>
            <el-table-column label="总价" width="100" prop="allPrice">
              <template slot-scope="scope">
                <span v-if="scope.row.allPrice">
                  ￥{{ scope.row.allPrice }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="consumeCount" label="已用" width="80">
              <template slot-scope="scope">
                {{ scope.row.consumeCount || 0 }}张
              </template>
            </el-table-column>
            <el-table-column prop="remainCount" label="剩余" width="80">
              <template slot-scope="scope">
                {{ scope.row.remainCount || 0 }}张
              </template>
            </el-table-column>
            <el-table-column
              prop="expirationDate"
              label="套餐有效期"
              width="200"
            ></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">正常</span>
                <span v-else-if="scope.row.status == 1">过期</span>
                <span v-else-if="scope.row.status == 2">失效</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="payMode"
              label="支付方式"
              fixed="right"
              width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.payMode == 0 ? "微信" : "" }}
                {{ scope.row.payMode == 1 ? "支付宝" : "" }}
                {{ scope.row.payMode == 3 ? "线下" : "" }}
              </template>
            </el-table-column>
          </el-table>

          <!-- 交易明细表格的分页器 -->
          <div class="pagination-container">
            <cus-pagination
              :total="transactionPageInfo.total"
              :current-page.sync="transactionPageInfo.currentPage"
              :page-size.sync="transactionPageInfo.pageSize"
              @current-change="handleTransactionCurrentChange"
              @size-change="fetchComboList"
            ></cus-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
import {
  getComboSummary,
  getTransactionDetails,
  getConsumerRecordList,
} from "@/api/combo";
import CusPagination from "@/components/cusPagination.vue";
import dayjs from "dayjs";
export default {
  name: "userDetailPackage",
  components: {
    CusPagination,
  },
  data() {
    return {
      recordList: [],
      loading1: false,
      loading2: false,
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      queryParams: {
        dateRange: [],
        type: "",
      },
      comboPageInfo: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      transactionPageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
      },
      queryForm: {
        type: "",
        code: "", // 修改订单编号查询条件的字段名
        orderTimeRange: [], // 下单时间范围查询条件
        payMode: "", // 支付方式查询条件
      },
      tableData: [],
      transactionData: [], // 交易明细数据
      activeTab: "shopping",
      pickerOptions: {
        // 可以添加日期选择器的快捷选项
      },
    };
  },
  mounted() {
    this.fetchComboSummary();
    this.fetchComboList();
    this.fetchConsumerRecords();
  },
  watch: {
    activeTab(newVal) {
      // this.transactionPageInfo.currentPage = 1;
      if (newVal === "shopping") {
        this.fetchConsumerRecords();
      } else if (newVal === "recharge") {
        this.fetchComboList();
      }
    },
  },
  created() {
    this.queryForm.createBy = this.$route.params.subId;
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.fetchConsumerRecords();
    },
    resetQuery() {
      this.queryParams = {
        dateRange: [],
        type: "",
      };
      this.currentPage = 1;
      this.fetchConsumerRecords();
    },
    async fetchConsumerRecords() {
      this.loading1 = true;
      try {
        const params = {
          ...this.queryParams,
          pageSize: this.pageSize,
          pageOn: this.currentPage,
          createBy: this.$route.params.subId,
        };

        if (params.dateRange && params.dateRange.length === 2) {
          const [beginTime, endTime] = params.dateRange;
          params.beginTime = dayjs(beginTime).format("YYYY-MM-DD 00:00:00");
          params.endTime = dayjs(endTime).format("YYYY-MM-DD 23:59:59");
          delete params.dateRange;
        }

        const response = await this.$ajax.get(getConsumerRecordList(params));
        this.recordList = response?.data?.data?.records || [];
        this.total = response?.data?.data?.total || 0;
      } catch (error) {
        this.$message.error(`获取消费记录失败:${error}`);
      } finally {
        this.loading1 = false;
      }
    },
    async fetchComboSummary() {
      this.loading = true;
      try {
        const response = await this.$ajax.get(
          getComboSummary({
            userId: this.$route.params.subId,
            // pageNum: this.comboPageInfo.currentPage,
            // pageSize: this.comboPageInfo.pageSize,
          })
        );

        const data = response?.data;
        if (data?.code === 200 && data?.data) {
          this.tableData = data.data;
          this.comboPageInfo.total = data.total || 1;
        }
      } catch (error) {
        console.error("获取套餐概要失败:", error);
        this.$message.error("获取套餐概要失败");
      } finally {
        this.loading = false;
      }
    },
    /**
     * 获取交易明细
     */
    async fetchComboList(isSearch = false) {
      this.loading2 = true;
      try {
        const {
          type,
          code,
          orderTimeRange,
          payMode,
          createBy,
        } = this.queryForm;
        let [beginTime, endTime] = orderTimeRange || [];
        if (endTime) {
          endTime = endTime.split(" ")[0] + " 23:59:59";
        }
        const { currentPage, pageSize } = this.transactionPageInfo;

        const pageOn = isSearch ? 1 : currentPage;

        const { data } = await this.$ajax.get(
          getTransactionDetails({
            pageOn,
            pageSize,
            type,
            code,
            payMode,
            beginTime,
            endTime,
            createBy,
          })
        );

        const resData = data?.data?.records ?? [];
        const orderMap = new Map();

        let uniqueId = 0;
        resData.forEach((item) => {
          if (!orderMap.has(item.code)) {
            orderMap.set(item.code, {
              ...item,
              id: `parent_${uniqueId++}`,
              children: [],
            });
          } else {
            const childItem = {
              ...item,
              id: `child_${uniqueId++}`,
              code: "",
            };
            orderMap.get(item.code).children.push(childItem);
          }
        });

        this.transactionData = Array.from(orderMap.values());
        if (isSearch) {
          this.transactionPageInfo.currentPage = 1;
        }
        const pageInfo = data?.data ?? {};
        this.transactionPageInfo = {
          currentPage: pageInfo.current || 1,
          pageSize: pageInfo.size || 5,
          total: pageInfo.total || 0,
        };
      } catch (error) {
        if (error) {
          this.loading2 = false;
          this.transactionData = [];
          this.$message({
            message: `服务端错误：${error.message}`,
            type: "error",
          });
        }
      } finally {
        this.loading2 = false;
      }
    },
    handleTransactionCurrentChange(currentPage) {
      this.transactionPageInfo.currentPage = currentPage;
      this.fetchComboList();
    },
    onSubmit() {
      // 重置页码为1并获取数据
      this.transactionPageInfo.currentPage = 1;
      this.fetchComboList(true);
    },
    goToPurchase() {
      // 实现跳转到购买套餐页面的逻辑
      this.$router.push("/recharge-center/purchase-combo");
    },
    onReset() {
      this.queryForm = {
        type: "", // 重置时将 type 设为空字符串
        code: "",
        orderTimeRange: [],
        payMode: "",
        createBy: this.$route.params.subId,
      };
      this.fetchComboList(true);
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchConsumerRecords();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchConsumerRecords();
    },
  },
};
</script>
<style lang="scss" scoped>
.combo-container {
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  .combo-table,
  .transaction-table {
    width: 100%;
    margin-bottom: 20px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin: 30px 0 20px;
  }

  .search-form {
    margin-bottom: 20px;

    .form-row {
      display: flex;
      margin-bottom: 20px;
      gap: 30px;

      &:last-child {
        justify-content: space-between;
        margin-bottom: 0;
      }
    }

    .el-form-item {
      margin-bottom: 0;
      display: flex;
      align-items: center;

      .el-form-item__label {
        white-space: nowrap;
      }

      .el-form-item__content {
        flex: 1;
        margin-left: 10px;
      }
    }

    .left-item {
      flex-grow: 1;
    }
    .el-select {
      width: 200px;
    }

    .el-date-editor {
      width: 320px;
    }
  }

  // 添加表格表头样式
  ::v-deep .el-table th {
    background-color: #f5f5f5 !important; // 设置表头背景色
  }

  // 添加固定列的样式
  ::v-deep .el-table {
    th {
      background-color: #f5f5f5 !important;
    }

    .el-table__fixed-right::before,
    .el-table__fixed::before {
      background-color: #f5f5f5;
    }
  }

  .pagination-container {
    margin-top: 20px;
  }

  ::v-deep .el-table {
    th,
    td {
      text-align: center;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 200px 0;

    .empty-image {
      width: 150px;
      height: 150px;
      margin-bottom: 50px;
    }

    .empty-text {
      font-size: 16px;
      color: #909399;
      margin-bottom: 50px;
    }

    .purchase-btn {
      padding: 10px 30px;
      background: linear-gradient(180deg, #6877ff 0%, #4bbeff 100%);
      border-radius: 24px;
      color: #fff;
      border: none;
    }
  }
}
</style>
